import { BodyS } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import React from 'react';
import ConfirmationDialog from 'components/ConfirmationDialog/ConfirmationDialog';

interface IDetachConfirmationDialogProps {
	isOpen: boolean;
	hideDialog: () => void;
	detach: () => void;
}
const DetachConfirmationDialog = ({ isOpen, hideDialog, detach }: IDetachConfirmationDialogProps) => {
	return (
		<ConfirmationDialog
			isOpen={isOpen}
			hideDialog={hideDialog}
			header={translate('number.details.detach.user.confirmation.title')}
			dialogBody={<BodyS>{translate('number.details.detach.user.confirmation.description')}</BodyS>}
			buttons={[
				{
					text: translate('cancel'),
					onClick: hideDialog,
					color: 'tertiary-light',
				},
				{
					text: translate('number.details.detach.user'),
					onClick: detach,
					color: 'primary-light',
				},
			]}
		/>
	);
};

export default DetachConfirmationDialog;
